import React from 'react';
import Theme from '../theme/theme';
import lemonadeGlobalThemeData from '../theme/global_data';

const themeData = {
  navbar_logo: '/branding/purple-pipp-logo.png',
  footer_logo: '/branding/purple-pipp-logo.png',
  invoice_logo: '/branding/purple-pipp-logo.png',
  fixed_navbar: {
    general_info: {
      featured_men_slugs: [],
      featured_women_slugs: [],
      featured_kids_slugs: []
    },
    desktop: {
      max_number_of_rows: 6,
      bottom_menu: {}
    },
    mobile: {
      preferred_tab_key: 'Women',
      tabs: []
    }
  },
  site_footer: {
    background: '#131313',
    copyright_notice_background: '#06645d',
    subscribe_section_text: 'Subscribe to our emailing list for the latest news!',
    social_media_icons: [],
    useful_links1: {
      title: '',
      links: []
    },
    useful_links2: {
      title: '',
      links: []
    },
    copyright_statement: '2017-2026 Lemonade Fashion, Inc.'
  },
  payment_logos: {
    payment_icons: []
  }
};

export const defaultTheme = new Theme(lemonadeGlobalThemeData(themeData));

const ThemeContext = React.createContext(defaultTheme);

export default ThemeContext;
